import { PhoneNumberUseCase } from "@redotech/redo-common-model/phone/phone-number";
import { MarketingSendConfigErrorCode } from "@redotech/redo-marketing-common/marketing-send-config-error";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const smsSenderHealthIssueSchema = z.object({
  teamId: z.string(),
  teamName: z.string(),
  useCase: createEnum(PhoneNumberUseCase),
  errorCode: z.nativeEnum(MarketingSendConfigErrorCode),
  errorMessage: z.string(),
  enabledFlowCount: z.number(),
});

export type SmsSenderHealthIssue = z.infer<typeof smsSenderHealthIssueSchema>;

export const getSmsSenderHealth = {
  name: "getSmsSenderHealth" as const,
  input: z.object({}),
  output: z.object({ issues: z.array(smsSenderHealthIssueSchema) }),
};
